import React from 'react'
import './TermsOfService.css'

const TermsOfService = () => {
  return (
    <div className="terms-of-service">
      <div className="terms-header">
        <h1>NepliShop Terms of Service</h1>
        <p className="effective-date">Last Updated: January 2026</p>
        <p className="terms-intro">
          Welcome to NepliShop! These Terms of Service govern your use of our website and services. By accessing or using NepliShop, you agree to be bound by these terms.
        </p>
      </div>

      <div className="terms-content">
        <section className="terms-section">
          <h2>1. Acceptance of Terms</h2>
          <div className="section-content">
            <p>By accessing and using NepliShop (neplishop.com), you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.</p>
          </div>
        </section>

        <section className="terms-section">
          <h2>2. Account Registration</h2>
          <div className="section-content">
            <ul>
              <li>You must be at least 16 years old to create an account</li>
              <li>Provide accurate and complete registration information</li>
              <li>Maintain the confidentiality of your account credentials</li>
              <li>Notify us immediately of any unauthorized account access</li>
              <li>You are responsible for all activities under your account</li>
            </ul>
          </div>
        </section>

        <section className="terms-section">
          <h2>3. Product Information and Pricing</h2>
          <div className="section-content">
            <ul>
              <li>We strive for accurate product descriptions and images</li>
              <li>Prices are subject to change without notice</li>
              <li>All prices are in Nepalese Rupees (NPR)</li>
              <li>Prices include applicable taxes unless specified otherwise</li>
              <li>Shipping charges are calculated at checkout</li>
              <li>We reserve the right to cancel orders for pricing errors</li>
            </ul>
          </div>
        </section>

        <section className="terms-section">
          <h2>4. Orders and Payments</h2>
          <div className="section-content">
            <ul>
              <li>Order confirmation does not guarantee product availability</li>
              <li>We accept payments through:
                <ul>
                  <li>Credit/Debit Cards (Visa, MasterCard)</li>
                  <li>Digital Wallets (eSewa, Khalti, Fonepay)</li>
                  <li>Bank Transfer (ConnectIPS)</li>
                  <li>Cash on Delivery (Available in select areas)</li>
                </ul>
              </li>
              <li>Payment processing is secured through PCI-DSS compliant gateways</li>
              <li>Orders are processed within 24-48 hours</li>
            </ul>
          </div>
        </section>

        <section className="terms-section">
          <h2>5. Shipping and Delivery</h2>
          <div className="section-content">
            <ul>
              <li>Delivery times: 3-5 hours within Kathmandu Valley, 1-3 days outside valley</li>
              <li>Shipping partners: Neplishop Partners, Nepal Post, Daraz Express, and local couriers</li>
              <li>Delivery charges vary by location</li>
              <li>International shipping available to selected countries</li>
              <li>Risk of loss passes to you upon delivery</li>
            </ul>
          </div>
        </section>

        <section className="terms-section">
          <h2>6. Returns and Refunds</h2>
          <div className="section-content">
            <ul>
              <li>7-day return policy for defective or damaged items</li>
              <li>Items must be unused, with original tags and packaging</li>
              <li>Refunds processed within 7-10 business days</li>
              <li>Return shipping costs borne by customer unless item is defective</li>
              <li>Certain items (undergarments, personalized items) are non-returnable</li>
            </ul>
          </div>
        </section>

        <section className="terms-section">
          <h2>7. Intellectual Property</h2>
          <div className="section-content">
            <p>All content on NepliShop, including logos, designs, text, and images, is our property and protected by Nepali and international copyright laws. You may not use our content without permission.</p>
          </div>
        </section>

        <section className="terms-section">
          <h2>8. User Conduct</h2>
          <div className="section-content">
            <p>You agree not to:</p>
            <ul>
              <li>Use the site for any illegal purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with site functionality</li>
              <li>Submit false or misleading information</li>
              <li>Use automated systems to access the site</li>
            </ul>
          </div>
        </section>

        <section className="terms-section">
          <h2>9. Disclaimer of Warranties</h2>
          <div className="section-content">
            <p>NepliShop provides services "as is" without warranties of any kind. We do not guarantee uninterrupted or error-free service.</p>
          </div>
        </section>

        <section className="terms-section">
          <h2>10. Limitation of Liability</h2>
          <div className="section-content">
            <p>NepliShop shall not be liable for any indirect, incidental, or consequential damages arising from your use of our services.</p>
          </div>
        </section>

        <section className="terms-section">
          <h2>11. Governing Law</h2>
          <div className="section-content">
            <p>These terms are governed by the laws of Nepal. Any disputes shall be subject to the exclusive jurisdiction of courts in Kathmandu, Nepal.</p>
          </div>
        </section>

        <section className="terms-section">
          <h2>12. Changes to Terms</h2>
          <div className="section-content">
            <p>We reserve the right to modify these terms at any time. Changes will be effective upon posting on our website.</p>
          </div>
        </section>

        <section className="terms-section">
          <h2>13. Contact Information</h2>
          <div className="section-content contact-details">
            <p><strong>NepliShop Pvt. Ltd.</strong></p>
            <p>Kathmandu, Nepal</p>
            <p>Email: neplishop.com@gmail.com</p>
            <p>Phone: +977 9741761406</p>
            <p>Website: www.neplishop.com</p>
            
        
          </div>
        </section>

        <div className="acceptance-section">
          <p className="acceptance-note">
            <strong>By using NEPLISHOP, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.</strong>
          </p>
          <p className="nepali-translation">
            <strong>नेपाली अनुवाद:</strong> NepliShop प्रयोग गर्दा तपाईंले यो सेवा सर्तहरू पढेर बुझेको र यसका शर्तहरूसँग बाँधिएको स्वीकार गर्नुहुन्छ।
          </p>
        </div>
      </div>
    </div>
  )
}

export default TermsOfService
